import { LINK, TextMatchTransformer } from '@lexical/markdown';

// The built-in LINK transformer's URL pattern is `[^()\s]+`, which forbids
// parentheses outright — so a link like
// `[Mercury](https://en.wikipedia.org/wiki/Mercury_(planet))` never matches
// and renders as raw markdown text (T2-11121). Per CommonMark, a link
// destination may contain balanced parentheses, so allow one level of
// nesting: each URL character is either a `(...)` pair with no parens inside,
// or any non-paren, non-whitespace character. The closing `\)` of the link
// still terminates the match, so prose parens wrapping a link are unaffected.
const URL_WITH_BALANCED_PARENS = /(?:\([^()\s]*\)|[^()\s])+/;

// The surrounding structure ([text], optional "title") mirrors the built-in
// LINK regexes; only the URL capture group differs.
const LINK_IMPORT_REGEXP = new RegExp(
  `(?:\\[(.+?)\\])(?:\\((${URL_WITH_BALANCED_PARENS.source})(?:\\s"((?:[^"]*\\\\")*[^"]*)"\\s*)?\\))`
);

// The text-match transformer's `regExp` fires on the trigger char, so it must
// be anchored to the end of the text; `importRegExp` (paste/import) must not be.
const LINK_END_REGEXP = new RegExp(`${LINK_IMPORT_REGEXP.source}$`);

/**
 * Drop-in replacement for the built-in LINK markdown transformer that accepts
 * balanced parentheses in the URL (e.g. Wikipedia disambiguation links).
 * Export and node replacement are inherited from the built-in transformer —
 * its match groups (text, url, title) are preserved in the same positions.
 */
export const linkTransformer: TextMatchTransformer = {
  ...LINK,
  importRegExp: LINK_IMPORT_REGEXP,
  regExp: LINK_END_REGEXP,
};
